import { render, staticRenderFns } from "./rmzxrmht.vue?vue&type=template&id=c55b25b8&scoped=true&"
import script from "./rmzxrmht.vue?vue&type=script&lang=js&"
export * from "./rmzxrmht.vue?vue&type=script&lang=js&"
import style0 from "./rmzxrmht.vue?vue&type=style&index=0&id=c55b25b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55b25b8",
  null
  
)

export default component.exports